import { createTemplateTag } from '../Tag';
import { extractValueWithPath } from '../ResolveValue';

export var props = createTemplateTag('props', function (path, context) {
  return extractValueWithPath(context.props, path);
});

export var string = createTemplateTag('string', function (path) {
  return path;
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/function-tree/es/tags/index.js
// module id = 249
// module chunks = 1